import React, { Fragment } from "react";
import { useForm } from "react-hook-form";
import {
  Row,
  Col,
  CardHeader,
  CardBody,
  CardFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Container,
  Button,
} from "reactstrap";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import ManageCandidate from "../../Components/Recruiter/ManageCandidate/ManageCandidate";
const ManageCandidatePage = () => {
  
  return (
    <Fragment>
      <Breadcrumbs title="Manage Candidate" mainTitle="Manage Candidate" />
      <Container fluid={true}>
        <ManageCandidate/>
      </Container>
    </Fragment>
  );
};

export default ManageCandidatePage;
